var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLiveChatSolution = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86385 9.96931C10.0458 9.96931 10.132 10.1909 10.0006 10.3161C9.15048 11.1211 7.7689 11.5 5.7786 11.5C4.28895 11.5 3.04621 11.2223 2.14066 10.6341L0.922543 10.9973C0.622972 11.0869 0.368537 10.7648 0.523794 10.4939L1.06549 9.54869C0.695469 8.94954 0.496434 8.2054 0.496434 7.30737C0.496434 5.25141 1.56682 4.00183 3.31705 3.4492C3.45863 3.40406 3.59953 3.52375 3.57559 3.6708C3.52087 3.99705 3.49352 4.33834 3.49352 4.69331C3.49352 6.42918 4.14053 7.82991 5.36481 8.74436C6.45366 9.55758 7.96587 9.97 9.85905 9.97L9.86385 9.96931ZM15.4764 8.32578L14.672 6.92231C14.9894 6.32453 15.1412 5.5845 15.1412 4.69263C15.1412 1.96229 13.2658 0.5 9.85905 0.5C7.32638 0.5 5.45919 1.33374 4.81902 3.15784C4.66102 3.60788 4.57758 4.11947 4.57758 4.69263C4.57758 7.58848 6.64585 8.88525 9.85905 8.88525C10.214 8.88525 10.5498 8.87294 10.8658 8.849C11.8254 8.77513 12.612 8.58842 13.2357 8.27995L15.0769 8.82917C15.3758 8.91808 15.6316 8.59662 15.4764 8.32578Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLiveChatSolution);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_live_chat_solution.155fb74066545c062526490607239197.svg";